import React from "react";
import { C } from "../lib/theme";

// A simple animated five-year-old face with three moods.
export default function Pip({ mood = "curious", size = 120 }) {
  const eyeY = mood === "delighted" ? 46 : 44;
  return (
    <div className="flex flex-col items-center" data-testid="pip-avatar">
      <svg width={size} height={size} viewBox="0 0 120 120" className="anim-fade-up">
        <defs>
          <radialGradient id="pipFace" cx="50%" cy="40%">
            <stop offset="0%" stopColor="#FDE7B8" />
            <stop offset="100%" stopColor="#F5C877" />
          </radialGradient>
        </defs>
        <circle cx="60" cy="60" r="46" fill="url(#pipFace)" stroke={C.amb} strokeWidth="2" />
        {/* eyes */}
        {mood === "delighted" ? (
          <>
            <path d="M40 46 q6 -8 12 0" stroke="#3a2a12" strokeWidth="3" fill="none" strokeLinecap="round" />
            <path d="M68 46 q6 -8 12 0" stroke="#3a2a12" strokeWidth="3" fill="none" strokeLinecap="round" />
          </>
        ) : (
          <>
            <circle cx="46" cy={eyeY} r={mood === "confused" ? 5 : 4} fill="#3a2a12" />
            <circle cx="74" cy={eyeY} r={mood === "confused" ? 5 : 4} fill="#3a2a12" />
          </>
        )}
        {/* brows for confused */}
        {mood === "confused" && (
          <>
            <path d="M40 34 l12 4" stroke="#3a2a12" strokeWidth="2.5" strokeLinecap="round" />
            <path d="M80 34 l-12 4" stroke="#3a2a12" strokeWidth="2.5" strokeLinecap="round" />
          </>
        )}
        {/* mouth */}
        {mood === "delighted" && <path d="M44 74 q16 18 32 0" stroke="#3a2a12" strokeWidth="3" fill="#e56a6a" strokeLinecap="round" />}
        {mood === "curious" && <circle cx="60" cy="76" r="5" fill="none" stroke="#3a2a12" strokeWidth="3" />}
        {mood === "confused" && <path d="M48 78 q12 -8 24 0" stroke="#3a2a12" strokeWidth="3" fill="none" strokeLinecap="round" />}
        {/* cheeks */}
        <circle cx="38" cy="64" r="5" fill="#f7a8a8" opacity="0.6" />
        <circle cx="82" cy="64" r="5" fill="#f7a8a8" opacity="0.6" />
      </svg>
      <div className="mt-1 font-mono text-[11px] uppercase tracking-wider" style={{ color: C.amb }}>
        Pip · {mood}
      </div>
    </div>
  );
}
